import styled, { css } from 'styled-components';
import Typography from '../../styles/Typography';
import { StyledTableRowProps } from './types';

export const StyledTable = styled.table`
  width: 100%;
  min-width: 640px;
  border-collapse: separate;
  border-spacing: 0;
`;

export const StyledTableHeadText = styled(Typography).attrs({
  forwardedAs: 'h3',
  variant: 'caption',
})`
  color: var(--muted);
  padding: var(--s-2) 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const StyledTableBody = styled.tbody`
  width: 100%;
`;

export const StyledTableRow = styled.tr<StyledTableRowProps>`
  transition: background-color var(--dur-fast) var(--ease-out);
  position: relative;

  & > td {
    border-bottom: 1px solid rgba(9, 15, 56, 0.06);
    transition: background-color 180ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  & > td:first-child {
    padding-left: 0.875rem;
    border-top-left-radius: var(--r-md);
    border-bottom-left-radius: var(--r-md);
    position: relative;
  }

  & > td:last-child {
    padding-right: 0.875rem;
    border-top-right-radius: var(--r-md);
    border-bottom-right-radius: var(--r-md);
  }

  & > td:first-child::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    height: 0;
    width: 3px;
    background: var(--brand-green);
    border-radius: 0 2px 2px 0;
    transition: height 200ms cubic-bezier(0.4, 0, 0.2, 1),
      top 200ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  ${({ clickable }) =>
    clickable &&
    css`
      &:hover {
        cursor: pointer;
      }
      &:hover > td {
        background-color: var(--brand-green-soft);
      }
      &:hover > td:first-child::before {
        height: 60%;
        top: 20%;
      }
    `}

  ${({ hot }) =>
    hot &&
    css`
      & > td {
        background-color: var(--brand-green-soft);
      }
      & > td:first-child::before {
        height: 60%;
        top: 20%;
      }
    `}

  &:last-child > td {
    border-bottom: none;
  }
`;

export const StyledTableHead = styled.thead`
  position: sticky;
  top: var(--topbar-h, 64px);
  z-index: 2;
  background-color: var(--paper);

  & > ${StyledTableRow} > td {
    background-color: var(--paper);
    border-bottom: 1px solid var(--line);
  }

  & > ${StyledTableRow}:hover {
    cursor: initial;
    background-color: initial;
  }
`;

export const StyledTableCell = styled.td`
  vertical-align: middle;
  font-family: var(--font-sans);
  font-size: var(--t-base);
  font-weight: 400;
  color: var(--ink-2);
  letter-spacing: -0.005em;
  font-variant-numeric: tabular-nums;
  &:not(:last-child) {
    padding-right: 1.25rem;
  }
`;

export const StyledTableCellContent = styled.div`
  min-height: 3.25rem;
  padding: 0.875rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
